import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CardProps {
  wrapperClass?: string;
}

const Card: React.FC<CardProps> = ({ children, wrapperClass = '', ...rest }) => {
  const classes = useStyles();

  return (
    <Box className={cx(classes.wrapper, wrapperClass)} {...rest}>
      {children}
    </Box>
  );
};

export default Card;
